import React from 'react';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Form, InputGroup } from 'react-bootstrap';

import * as videoOps from '../../../api/Videos/video-operations';
import { getOptionsForCoordinateDataType, VIDEO_OPTIONS } from '../../../api/Videos/Videos';

const VideoOptionForm = ({ video, isPublic, changeOption }) => {
  if (isPublic) {
    return '';
  }
  return (
    <>
      <InputGroup.Prepend>
        <InputGroup.Text>Map Config.</InputGroup.Text>
      </InputGroup.Prepend>
      <Form.Control as="select" defaultValue={videoOps.getOption(video)} onChange={changeOption}>
        <option value="">-</option>
        {map(
          getOptionsForCoordinateDataType(
            videoOps.areCoordinatesFromPoint(video),
            videoOps.areCoordinatesUndefined(video)
          ),
          (value, key) => {
            return (
              <option value={value} key={value}>
                {VIDEO_OPTIONS.properties[key].humanValue}
              </option>
            );
          }
        )}
      </Form.Control>
    </>
  );
};

VideoOptionForm.propTypes = {
  video: PropTypes.object.isRequired,
  isPublic: PropTypes.bool.isRequired,
  changeOption: PropTypes.func.isRequired
};

export default VideoOptionForm;
